<template>
  <Banner heroType="interior" 
    title="Something Went Wrong" 
    subtitle="Please try again or contact support if the problem persists."
    screenLabel="Error — Hero"
  />
  
  <div class="container mt-5 mb-5">
    <div id="error-wrapper">
      <div class="alert alert-danger text-center" role="alert">
        <h2>{{ errorMessage }}</h2>
        <p>{{ errorDetails }}</p>
        <router-link to="/Home" class="btn btn-primary mt-3">Return to Home</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/UI/Banner.vue';

export default {
  name: 'ErrorPage',
  components: {
    Banner
  },
  data() {
    return {
      errorMessage: 'An Error Occurred',
      errorDetails: 'We encountered an unexpected error. Please try again or contact support.',
    };
  },
  mounted() {
    // Get error details from route params if available
    const errorCode = this.$route.query.code;
    const errorMsg = this.$route.query.message;
    
    if (errorMsg) {
      this.errorMessage = errorMsg;
    }
    if (errorCode) {
      this.errorDetails = `Error Code: ${errorCode}`;
    }
  },
};
</script>

<style scoped>
#error-wrapper {
  max-width: 70%;
  margin: 0 auto;
  padding: 40px 0;
}

@media screen and (max-width: 575px) {
  #error-wrapper {
    max-width: 100%;
    margin: 0 auto;
  }
}
</style>
